<div class="az-selector" data-testid="az-selector" [class.az-selector--disabled]="disabled">
  @if (label) {
    <label class="az-selector__label">{{ label }}</label>
  }

  <div
    #control
    class="az-selector__control"
    data-testid="az-selector-control"
    (click)="toggleDropdown()"
    [class.az-selector__control--disabled]="disabled"
  >
    <span class="az-selector__selected">{{ selectedValue || 'Select an option' }}</span>
    <div class="az-selector__arrow-container">
      <span class="material-symbols-outlined az-selector__arrow" aria-hidden="true">
        {{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </span>
    </div>
  </div>

  @if (isOpen && !disabled) {
    <div
      class="az-selector__dropdown"
      data-testid="az-selector-dropdown"
      [style.top.px]="dropdownTop"
      [style.left.px]="dropdownLeft"
      [style.width.px]="dropdownWidth"
    >
      @for (option of options; track getOptionTrackKey(option)) {
        <div
          class="az-selector__option"
          data-testid="az-selector-option"
          (click)="selectOption(option)"
          [class.az-selector__option--selected]="isOptionSelected(option)"
        >
          {{ getOptionLabel(option) }}
        </div>
      }
    </div>
  }
</div>
